import { defineComponent, computed, watch, ref } from 'vue';
import { Cell, Checkbox, CheckboxGroup } from 'vant';
export default defineComponent({
    name: 'CellSelect',
    components: {
        'van-cell': Cell,
        'van-checkbox': Checkbox,
        'van-checkbox-group': CheckboxGroup
    },
    props: {
        modelValue: {
            type: Object
        },
        options: {
            type: Array,
            default: ()=>[]
        },
        type: {
            type: String,
            default: 'radio'
        },
        max: {
            type: Number,
            default: 0
        },
        optionAsValue: {
            type: Boolean,
            default: false
        }
    },
    emits: [
        'update:modelValue',
        'input',
        'change'
    ],
    setup (props, param) {
        let { emit } = param;
        const checkboxes = ref();
        const needEmitChange = ref(true);
        const realValue = ref([]);
        const indexForRadio = ref(0);
        const realOptionAsValue = computed(()=>typeof props.optionAsValue === 'string' || !!props.optionAsValue);
        const realMax = computed(()=>{
            if (props.type === 'radio') return 0;
            return props.max;
        });
        function emitUpdateValue(value) {
            emit('update:modelValue', value);
        }
        function emitInput(value) {
            emit('input', value);
        }
        function emitChange(value) {
            emitUpdateValue(value);
            emitInput(value);
            emit('change', value);
        }
        function transIndexForRadio() {
            const value = props.modelValue;
            const options = props.options;
            if (options) {
                if (realOptionAsValue.value) {
                    indexForRadio.value = options.indexOf(value);
                    indexForRadio.value = Math.max(0, indexForRadio.value);
                } else {
                    const has = options.some((option, index)=>{
                        const res = option.value === value;
                        if (res) {
                            indexForRadio.value = index;
                        }
                        return res;
                    });
                    if (!has) indexForRadio.value = 0;
                }
            }
        }
        // 对 radio 和 checkbox 做统一的数据结构处理
        function transRealValue() {
            let needEmit = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
            if (props.type === 'radio') {
                if (props.modelValue instanceof Array) {
                    realValue.value = props.modelValue;
                } else if (props.modelValue) {
                    realValue.value = [
                        props.modelValue
                    ];
                } else {
                    realValue.value = [];
                }
                needEmitChange.value = needEmit;
                transIndexForRadio();
            } else {
                realValue.value = props.modelValue;
            }
        }
        function handleGroupChange(value) {
            if (needEmitChange.value) {
                if (props.type === 'radio' && value.length) {
                    emitChange(value.pop());
                } else if (props.type === 'checkbox') {
                    emitChange(value);
                }
            } else {
                needEmitChange.value = true;
            }
        }
        transRealValue(true);
        function handleOptionChange(index) {
            if (props.type === 'radio') {
                try {
                    checkboxes.value[indexForRadio.value].toggle(false);
                } catch (error) {}
                checkboxes.value[index].toggle(true);
                if (indexForRadio.value === index) {
                    if (realOptionAsValue.value) {
                        emitChange(props.options[index]);
                    } else {
                        emitChange(props.options[index].value);
                    }
                }
                indexForRadio.value = index;
            } else {
                checkboxes.value[index].toggle();
            }
        }
        // 判定当前是否为选中的值
        function judgeIsCurrent(item) {
            if (realOptionAsValue.value) {
                return realValue.value.map((option)=>option.value).includes(item.value);
            }
            return realValue.value.includes(item.value);
        }
        watch(()=>props.modelValue, ()=>{
            const needEmit = props.type !== 'radio';
            transRealValue(needEmit);
        });
        return {
            realMax,
            realValue,
            checkboxes,
            realOptionAsValue,
            judgeIsCurrent,
            handleGroupChange,
            handleOptionChange
        };
    }
});
